/* Copyright (c) 2022 MOCA Systems, Inc. All rights reserved. */

export enum ExternalLinkage {
	AllTickets = 'any',
	WithExternalScheduleID = 'linked',
	WithoutExternalScheduleID = 'unlinked',
}
